import { Routes } from '@angular/router'

import { authGuard } from '@treves/core/auth/auth.guard'
import { redirectIfAuthGuard } from '@treves/core/auth/redirect-if-auth.guard'

import { environment } from '@treves/env/environment'

import { adminGuard } from './core/auth/admin.guard'

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layouts/main/main-layout.component').then((m) => m.MainLayoutComponent),
    children: [
      {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent)
      },
      {
        path: 'qrqc-assistant',
        canActivate: [authGuard],
        loadComponent: () =>
          import('@yoshu-lib/features/treves/pages/qrqc-chat-entry/qrqc-chat-entry.component').then(
            (m) => m.QrqcChatEntryComponent
          )
      },
      {
        path: 'qrqc-history',
        canActivate: [authGuard],
        loadComponent: () =>
          import('@yoshu-lib/features/treves/pages/qrqc-history/qrqc-history.component').then(
            (m) => m.QrqcHistoryComponent
          )
      },
      {
        path: 'chat/:interactionId',
        canActivate: [authGuard],
        loadComponent: () =>
          import('@yoshu-lib/features/interaction-modes/free-mode/free-mode.component').then(
            (m) => m.FreeModeComponent
          ),
        data: { workflow: 'rag' }
      }
    ]
  },

  ...(environment.features['module.admin']
    ? [
        {
          path: 'admin',
          canActivate: [adminGuard],
          loadChildren: () => import('./pages/admin/admin.routes').then((m) => m.routes)
        } satisfies Routes[number]
      ]
    : []),

  {
    path: 'login',
    canActivate: [redirectIfAuthGuard],
    loadComponent: () => import('@yoshu-lib/ui/login').then((m) => m.LoginComponent)
  },

  {
    path: '**',
    redirectTo: ''
  }
]
